import { Link } from 'react-router-dom';
import { Leaf, Mail, Phone, MapPin, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="main-footer">
      {/* Green Strip */}
      <div className="h-1 bg-[#056839]" />
      
      {/* Main Footer */}
      <div className="bg-[#4A4A4A] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
            {/* Brand - Takes more space */}
            <div className="md:col-span-4">
              <div className="mb-1">
                <img 
                  src="/africycle-logo-new.png" 
                  alt="AfriCycle Zambia - EPR Compliance for Plastic Packaging and WEEE Recycling" 
                  className="h-20 md:h-24 w-auto object-contain"
                />
              </div>
              <p className="text-gray-300 text-sm leading-relaxed max-w-xs">
                Your gateway to plastic packaging and WEEE EPR compliance in Zambia.
              </p>
            </div>

            {/* Services */}
            <div className="md:col-span-2">
              <h4 className="font-semibold text-lg mb-5 text-white">SERVICES</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/services#compliance" className="text-gray-300 hover:text-white text-sm transition-colors">
                    EPR Compliance
                  </Link>
                </li>
                <li>
                  <Link to="/services#waste-collection" className="text-gray-300 hover:text-white text-sm transition-colors">
                    Waste Collection & Treatment
                  </Link>
                </li>
                <li>
                  <Link to="/calculator" className="text-gray-300 hover:text-white text-sm transition-colors">
                    Fee Calculator
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className="md:col-span-2">
              <h4 className="font-semibold text-lg mb-5 text-white">COMPANY</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-gray-300 hover:text-white text-sm transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/knowledge" className="text-gray-300 hover:text-white text-sm transition-colors">
                    Knowledge Hub
                  </Link>
                </li>
                <li>
                  <span className="text-gray-300 text-sm">Privacy Policy</span>
                </li>
                <li>
                  <span className="text-gray-300 text-sm">Terms of Service</span>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="md:col-span-4">
              <h4 className="font-semibold text-lg mb-5 text-white">CONTACT</h4>
              <ul className="space-y-4">
                <li>
                  <a href="mailto:k.banda@africycle.pro" className="flex items-center gap-3 text-gray-300 hover:text-white text-sm transition-colors">
                    <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <Mail className="h-4 w-4 text-white" />
                    </div>
                    k.banda@africycle.pro
                  </a>
                </li>
                <li>
                  <a href="tel:+260977150933" className="flex items-center gap-3 text-gray-300 hover:text-white text-sm transition-colors">
                    <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <Phone className="h-4 w-4 text-white" />
                    </div>
                    +260 977150933
                  </a>
                </li>
                <li>
                  <div className="flex items-center gap-3 text-gray-300 text-sm">
                    <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                      <MapPin className="h-4 w-4 text-white" />
                    </div>
                    Lusaka, Zambia
                  </div>
                </li>
              </ul>
              
              {/* Follow Us */}
              <div className="mt-6 pt-4 border-t border-white/20">
                <p className="text-gray-400 text-sm mb-3">Follow us</p>
                <a 
                  href="https://www.linkedin.com/company/africyclewastewizards/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
                  data-testid="linkedin-link"
                >
                  <div className="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors">
                    <Linkedin className="h-4 w-4 text-white" />
                  </div>
                  <span className="text-sm">LinkedIn</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} AfriCycle Zambia. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Leaf className="h-4 w-4 text-[#69A488]" />
              <span>EPR compliance for plastic packaging and WEEE in Zambia</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
